// material-ui
import { useTheme } from '@mui/material/styles';
import logo from 'assets/images/logos/priseen-enterprise-logo.svg';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const PriseenLogo = ({ width }) => {
  const theme = useTheme();

  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={logo} alt="" width="100" />
     *
     */
    <>
      <img src={logo} alt="Priseen" width={width || '150'} />
    </>
  );
};

export default PriseenLogo;
